import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SortingService {


  sortArrayByProperty<T>(array: T[], propertyName: string, ascending: boolean): T[] {
    if (!array || array.length === 0 || !propertyName || propertyName.isNullOrWhitespace()) {
      return array;
    }

    return array.sort((a, b) => {
      let direction = 1;
      if (!ascending) {
        direction = -1;
      }
      return direction * this.sortBySpecifiedProperty(a, b, propertyName);
    });


  }

  sortBySpecifiedProperty(a: any, b: any, property: string) {
    const textA = a[property] ? a[property].toUpperCase() : '';
    const textB = b[property] ? b[property].toUpperCase() : '';

    if (textA > textB) {
      return 1;
    } else if (textA === textB) {
      return 0;
    } else {
      return -1;
    }
  }


  sortByName(a: any, b: any): number {
    const textA = a.name.toUpperCase();
    const textB = b.name.toUpperCase();
    if (textA > textB) {
      return 1;
    } else if (textA === textB) {
      return 0;
    } else {
      return -1;
    }
  }


  sortStrings(a: string, b: string): number {
    const textA = a.toUpperCase();
    const textB = b.toUpperCase();
    if (textA > textB) {
      return 1;
    } else if (textA === textB) {
      return 0;
    } else {
      return -1;
    }
  }

}
